import React, { RefObject } from 'react'

type ContentBlockContext = {
    contentReviewsRef: null | RefObject<HTMLDivElement>
}
const DefaultContentBlockContext: ContentBlockContext = {
    contentReviewsRef: null,
}

export const ContentBlockContext = React.createContext(
    DefaultContentBlockContext,
)
